import { Component } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: false,
})
export class LayoutComponent {
  selectedProduct!: string;
  enableOverview: boolean = false;

  onProductSelected(product: string): void {
    this.selectedProduct = product;
  }

  enableOverviewed(isactive: boolean): void {
    this.enableOverview = isactive;
  }
}
